
import { Component, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ETipoPreferencia, ETipoProducto } from 'src/app/models/enums.enum';
import { IPreferencia } from 'src/app/models/interfaces-apis/diccionarios';
import { ObservacionesComponent } from '../../../form-componentes/observaciones/observaciones.component';
import { IFichaCliente, IPreferenciaCliente } from 'src/app/models/interfaces-apis/ficha_cliente';
import { preferencias } from 'src/app/models/General/preferencias';
import { GrupoPreferenciaComponent } from '../../../form-componentes/grupo-preferencia/grupo-preferencia.component';
import { UserService } from 'src/app/servicios/user.service';
@Component({
  selector: 'app-preferencias-transfer',
  templateUrl: './preferencias-transfer.component.html',
  styleUrls: ['./preferencias-transfer.component.scss']
})
export class PreferenciasTransferComponent extends preferencias implements OnInit {


  @ViewChild('Grupo_Preferencia_Transfer_Observaciones') Grupo_Preferencia_Transfer_Observaciones: ObservacionesComponent;
  @ViewChildren('Grupo_Preferencia_Transfer') grupos!: QueryList<GrupoPreferenciaComponent>;
  
  constructor(private _userService: UserService) {
    super();
  }

  ngOnInit(): void {
  }

  ETipoProducto = ETipoProducto;
  TipoPreferencia = ETipoPreferencia;

  @Input() preferencias: IPreferencia[];

  @Input() clienteFicha: IFichaCliente;
  @Input() listaOtros: string[];

  //Obtener la lista de las preferencias transfer guardadas
  obtenerPreferenciasGuardadas(): IPreferenciaCliente[] {

    let ListaPreferencias: IPreferenciaCliente[] = [];

    this.grupos.forEach((grupo) => {
      let resultado = grupo.obtenerPreferencias();
      let opcionesPreferencias: IPreferenciaCliente = {
        Tipo: grupo.Id,
        Preferencias: resultado[0],
        InfoEspecifica: resultado[1]
      };
      ListaPreferencias.push(opcionesPreferencias);
    });

    let textoObservacion = this.Grupo_Preferencia_Transfer_Observaciones.obtenerPreferencias()
    let preferenciaTransferObservaciones: IPreferenciaCliente = {
      Tipo: this._userService.getTipoPreferenciasId('ObservacionTransfer'),
      Preferencias: null,
      InfoEspecifica: textoObservacion,
    }
    ListaPreferencias.push(preferenciaTransferObservaciones)

    return ListaPreferencias;

  }

  //Actualizar preferencias transfer
  actualizar() {
    let preferencias = this.clienteFicha.Preferencias
    let preferenciasTipoTransfer = this.preferencias.filter(o => o.TipoProducto === ETipoProducto.Transfer);
    let idsPreferencias = preferenciasTipoTransfer.map(o => o.Id);
    let resultado = preferencias.filter(o => idsPreferencias.includes(o.Tipo));
    this.grupos.forEach((grupo) => {
      const preferencia = resultado.find(p => p.Tipo === grupo.Id);
      if (preferencia) {
        grupo.actualizar(preferencia.Preferencias, preferencia.InfoEspecifica);
      }
    });

    let preferenciaTextoObservacionTransfer: IPreferenciaCliente = this.obtenerPreferenciasCliente(preferencias, this._userService.getTipoPreferenciasId('ObservacionTransfer'))

    this.Grupo_Preferencia_Transfer_Observaciones.actualizar(preferenciaTextoObservacionTransfer?.InfoEspecifica);
  }

  //Validar preferencias Transfer
  validarPreferencias() {
    let validacionPreferenciasTransfer = this.grupos.toArray().every(grupo => grupo.validarPreferencias());
    return validacionPreferenciasTransfer;
  }

}

